var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.83132V7.81928C6.25 4.60538 8.82436 2 12 2C15.1756 2 17.75 4.60538 17.75 7.81928V7.83132H20C20.5523 7.83132 21 8.28443 21 8.84337V17.9518C21 20.1876 19.2091 22 17 22H7C4.79086 22 3 20.1876 3 17.9518V8.84337C3 8.28443 3.44772 7.83132 4 7.83132H6.25ZM7.75 7.81928V7.83132H16.25V7.81928C16.25 5.44379 14.3472 3.51807 12 3.51807C9.65279 3.51807 7.75 5.44379 7.75 7.81928ZM17 11.8795C17.5523 11.8795 18 11.4264 18 10.8675C18 10.3085 17.5523 9.85542 17 9.85542C16.4477 9.85542 16 10.3085 16 10.8675C16 11.4264 16.4477 11.8795 17 11.8795ZM8 10.8675C8 10.3085 7.55228 9.85542 7 9.85542C6.44772 9.85542 6 10.3085 6 10.8675C6 11.4264 6.44772 11.8795 7 11.8795C7.55228 11.8795 8 11.4264 8 10.8675Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.11d5c9439fa84ac056f40a1f50b52f21.svg";
export { ForwardRef as ReactComponent };